import { List } from "immutable";

import { SubjectGroup } from "@seneca/tags-service-consts";

import Tag from "../../../models/Tag";

export const getId = (state: Tag) => {
  return state.id;
};

export const getName = (state: Tag) => {
  return state.text;
};

export const getParentId = (state: Tag) => {
  return state.parentId;
};

export const getCategoryIds = (state: Tag): List<string> => {
  return state.categoryIds;
};

export const applyPremiumStyleToFilter = (state: Tag) => {
  return state.details && state.details.get("applyPremiumStyleToFilter");
};

export const enableSectionPreview = (state?: Tag) => {
  return (
    !!state && !!state.details && !!state.details.get("enableSectionPreview")
  );
};

export const showAssignmentSelfMarkedQuestions = (state?: Tag) => {
  return (
    !!state &&
    !!state.details &&
    !!state.details.get("showAssignmentSelfMarkedQuestions")
  );
};

export const showCardAdOnYourCoursesPage = (state: Tag) => {
  return state.details && state.details.get("showCardAdOnYourCoursesPage");
};

export const getDescription = (state: Tag): string | null | undefined => {
  return state.details && state.details.get("description");
};

export const getSubjectGroup = (
  state: Tag
): SubjectGroup | null | undefined => {
  return state.get("subjectGroup");
};

export const getTagCoursesFilterOnly = (state: Tag) => {
  return state.get("coursesFilterOnly");
};

export const isHidden = (state: Tag) => {
  return state.details && state.details.get("hidden");
};

export const getDetails = (state: Tag): Record<string, any> => {
  return state.details;
};

export const getSemanticCategory = (state: Tag) => {
  return state.semanticCategory;
};
